import { Flex } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import { useNavigate } from 'react-router-dom'

export default function MachineActions({ member }: MemberProps<ILineItem>) {
  const { tCore } = useTranslation({ scope: 'product_list', recordType: RecordType.line_item })
  if (!member) return null
  const canBeSetVacant = member.checkupEnabled && !member.vacant && member.filterStatus == 'current'

  if (canBeSetVacant) return null

  // condition to show the button
  const navigate = useNavigate()
  const onClick = () =>
    navigate(Routes.Machine.member(member.id, member.rental_id, true).machine_interaction)

  return (
    <Flex>
      <Button
        onClick={onClick}
        type="primary"
        style={{ marginBottom: 8 }}
        title={tCore({ id: 'vacant_or_extend' })}
      />
    </Flex>
  )
}
